/*
  P35 (owner, 27 Oct 2026): the UK twin of assets/zv-eta.js, for The Power Cut Box (CJ's agent confirmed one parcel, 7 to 8 days to the UK; the page says 7 to 10 working days,
  two days of buffer). Any element with data-zv-eta-gb="<min>-<max>" (working days) reads "<pre><today + min> – <today + max>." in the visitor's own calendar, UK style
  ("Thu 5 – Tue 10 Nov", "Mon 23 – Thu 26 Nov"); weekends and England and Wales bank holidays (no Royal Mail delivery) are skipped. data-zv-eta-pre sets the words
  before the dates (default "Arrives "). The server prints the plain window first, so the line is never empty. Used by sections/zvf-powercut.liquid and
  sections/zvf-home-ready.liquid only; zv-eta.js (US) is unchanged. Extend HOLIDAYS before the end of 2027.
*/
(function () {
  if (window.zvEtaGb) return;
  var HOLIDAYS = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var key = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
  var add = function (from, n) {
    var x = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      var w = x.getDay();
      if (w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(x)) < 0) n--;
    }
    return x;
  };
  var day = function (d) { return DAYS[d.getDay()] + ' ' + d.getDate(); };
  var range = function (min, max, now) {
    now = now || new Date();
    var a = add(now, min), b = add(now, max);
    if (a.getMonth() === b.getMonth()) return day(a) + ' – ' + day(b) + ' ' + MONTHS[b.getMonth()];
    return day(a) + ' ' + MONTHS[a.getMonth()] + ' – ' + day(b) + ' ' + MONTHS[b.getMonth()];
  };
  var fill = function () {
    var els = document.querySelectorAll('[data-zv-eta-gb]');
    for (var i = 0; i < els.length; i++) {
      var r = String(els[i].getAttribute('data-zv-eta-gb')).split('-');
      var a = parseInt(r[0], 10), b = parseInt(r[1] || r[0], 10);
      if (!(a > 0 && b >= a)) continue;
      var pre = els[i].getAttribute('data-zv-eta-pre');
      var t = (pre === null ? 'Arrives ' : pre) + range(a, b) + '.';
      if (els[i].textContent !== t) els[i].textContent = t;
    }
  };
  window.zvEtaGb = { range: range, add: add, fill: fill };
  fill();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill);
})();
